/* Catalogue only. Event delegation also covers filtered/infinite-scroll cards. */
(function () {
  'use strict';
  if (window.nsCollectionQuickAdd) return;
  window.nsCollectionQuickAdd = true;
  document.addEventListener('click', async function (event) {
    var button = event.target.closest('[data-ns-quick-add]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    if (button.disabled) return;
    var card = button.closest('[data-ns-quick-card]');
    var status = card.querySelector('[data-ns-quick-status]');
    var select = card.querySelector('[data-ns-quick-variant]');
    var size = card.querySelector('[data-ns-quick-size]');
    var options = card.querySelector('[data-ns-quick-options]');
    if (select && !select.value) {
      options.hidden = false;
      status.textContent = 'Choisissez une option avant l’ajout.';
      select.focus();
      return;
    }
    if (size && !size.value.trim()) {
      options.hidden = false;
      status.textContent = 'Indiquez votre pointure avant l’ajout.';
      size.focus();
      return;
    }
    var id = select ? select.value : button.dataset.variantId;
    if (!/^\d+$/.test(id || '')) {
      status.textContent = 'Produit indisponible. Consultez sa fiche.';
      return;
    }
    var item = { id: id, quantity: 1 };
    if (size) item.properties = { Pointure: size.value.trim().slice(0, 20) };
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    status.textContent = 'Ajout en cours…';
    try {
      var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      var response = await fetch(root + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [item] })
      });
      var data = await response.json();
      if (!response.ok) throw new Error(data.description || 'Ajout impossible. Réessayez.');
      status.textContent = 'Produit ajouté au panier.';
      if (window.Udesly && typeof window.Udesly.dispatch === 'function') {
        window.Udesly.dispatch('product-added', true);
      }
    } catch (error) {
      status.textContent = error.message || 'Connexion interrompue. Vérifiez votre panier avant de réessayer.';
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
})();
